module.exports = __webpack_public_path__ + "img/bg-events.2f3ba6f4.svg";